import type { JobsJobElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/jobs';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import { filesize } from '../../utils/filesize';

export function getFormattedFileSize(
  job: JobsJobElasticSchemaWithId,
  searchItem?: SearchItemEntity,
): string | undefined {
  const fileSetId =
    job.job_context?.file_set_id ?? job.job_context?.original_file_set_id;

  if (typeof fileSetId !== 'string') {
    return undefined;
  }

  // A file set can contain multiple files (e.g. original and proxy) sharing
  // the same file_set_id, so their sizes need to be summed for the true size.
  const matchingFiles = searchItem?.files?.filter(
    (file) => file.file_set_id === fileSetId,
  );

  if (!matchingFiles?.length) {
    return undefined;
  }

  const totalSize = matchingFiles.reduce(
    (sum, file) => sum + (file.size ?? 0),
    0,
  );

  return totalSize ? filesize(totalSize) : undefined;
}
